// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1Ltye","name":"ConsentHeader_name__11cQV","birthday":"ConsentHeader_birthday__2cTgA","skeleton":"ConsentHeader_skeleton__3tCuF"};